import React, { useRef } from "react";
import {
  Grid,
  Input,
  makeStyles,
  styled,
  IconButton,
  withTheme,
  Typography,
} from "@material-ui/core";

export default function TextField(props) {
  const {
    type,
    name,
    error,
    onBlur,
    onChange,
    helperText,
    disabled,
    placeholder,
    containerStyle,
    value,
    onClickIcon,
    select,
    iconComponent: IconComponent,
    style,
    multiline,
    rows,
    profile,
    fromProfile,
    inputComponent,
    id,
    onFocus,
    onKeyPress,
    className,
    inputRef,
    autoComplete,
    defaultValue,
    inputProps,
    ...rest
  } = props;
  const classes = useStyles({
    select,
    multiline,
    profile,
    fromProfile,
    ...props,
  })();

  const ref = useRef();
  return (
    <Grid
      container
      className={className}
      style={{ ...containerStyle, position: "relative" }}
    >
      <Grid
        container
        alignItems="center"
        item
        xs={12}
        sm={12}
        style={{ ...style, position: "relative" }}
      >
        <StyledInput
          className={classes.input}
          fullWidth
          disableUnderline
          defaultValue={defaultValue}
          autoComplete={autoComplete}
          profile={profile}
          value={value}
          multiline={multiline}
          inputRef={inputRef}
          onKeyPress={onKeyPress ? (e) => onKeyPress(e) : () => {}}
          rows={rows}
          onFocus={onFocus}
          placeholder={placeholder}
          inputProps={{ color: "#192A7F", ...inputProps }}
          type={type ? type : "text"}
          name={name}
          onChange={onChange ? (e) => onChange(e) : () => {}}
          onBlur={onBlur ? () => onBlur() : () => {}}
          error={error}
          disabled={disabled}
          ref={ref}
          id={id}
          inputComponent={inputComponent}
          {...rest}
        />
        {IconComponent && (
          <IconButton onClick={onClickIcon} style={{ position: "absolute", right: 0, zIndex: 1 }}>
            <IconComponent />
          </IconButton>
        )}
        {error && (
          <Typography className={classes.error} variant="caption">
            {helperText}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

const useStyles = ({ select, profile, fromProfile, ...props }) =>
  makeStyles((theme) => ({
    input: {
      "& ::placeholder": {
        color: theme.palette.primary.main,
        opacity: 1 /* Firefox */,
        fontWeight: props.fontWeight ? props.fontWeight : "400",
      },
      ": -ms-input-placeholder": {
        color: theme.palette.primary.main,
        fontWeight: props.fontWeight ? props.fontWeight : "400",
      },
      ":: -ms-input-placeholder": {
        /* Microsoft Edge */ color: theme.palette.primary.main,
        fontWeight: props.fontWeight ? props.fontWeight : "400",
      },
    },
    error: {
      fontSize: "0.7rem",
      position: "absolute",
      left: 3,
      top: "100%",
      marginTop: 5,
      color: "red",
      whiteSpace: "pre-line",
      zIndex: 1,
    },
    dateInput: {
      color: theme.palette.secondary.main,
      "&::-webkit-input-placeholder": {
        color: theme.palette.secondary.main /*Change the placeholder color*/,
        opacity: 1 /*Change the opacity between 0 and 1*/,
      },
    },
    datePicker: {
      height: props.profile || props.fromProfile ? "56px!important" : 43,
      borderRadius: 25,
      boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
      "& .MuiInput-underline": {
        height: "100%",
        "& input": {
          padding: "0 0 0 18px",
          fontSize: 12,
        },
        "& .MuiInputAdornment-root": {
          "& svg": {
            color: theme.palette.secondary.main,
          },
        },
      },
      "& .MuiInput-underline:before, .MuiInput-underline:after": {
        border: 0,
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        border: 0,
      },
    },
  }));

const StyledInput = styled(withTheme(Input))((props) => {
  return {
    background: "#fff",
    color: props.select
      ? `${props.theme.palette.secondary.main}`
      : `${props.theme.palette.primary.main}`,
    height: props.multiline ? "unset" : props.profile ? "56px!important" : 43,
    padding: props.multiline ? 18 : props.profile ? "0 13px" : "0 18px",
    boxSizing: props.profile ? "content-box" : "unset",
    fontWeight: !props.profile ? "unset" : "500",
    border:
      props.select || props.profile
        ? "unset"
        : props.error
        ? "1pt solid red"
        : "1pt solid #B2B2B2",
    boxShadow:
      props.select || props.profile
        ? "0px 4px 10px rgba(198, 198, 198, 0.5)"
        : "unset",
    borderRadius: props.profile ? 22 : 25,
    fontSize: props.profile ? "1.125rem" : 12,
    [props.theme.breakpoints.down("xs")]: {
      height: props.multiline ? "unset" : props.profile ? "56px!important" : 43,
    },
    "& svg": {
      right: 20,
      color: props.theme.palette.secondary.main,
    },
    "&:hover": {
      border:
        props.select || props.profile
          ? "unset"
          : props.error
          ? "1pt solid red"
          : "1pt solid #B2B2B2",
    },
    "&:after": {
      border: 0,
    },
    "&:before": {
      border: 0,
    },
    "&:focus": {
      border:
        props.select || props.profile
          ? "unset"
          : props.error
          ? "1pt solid red"
          : "1pt solid #B2B2B2",
    },
    "&:active": {
      border:
        props.select || props.profile
          ? "unset"
          : props.error
          ? "1pt solid red"
          : "1pt solid #B2B2B2",
    },
    "&.Mui-disabled": {
      border: "1pt solid #B2B2B2",
    },
    "&.Mui-disabled input::placeholder": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
    "&.Mui-disabled textarea::placeholder": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
  };
});
